







import { goDownloadWx } from '@/utils';
import { Component, Vue } from 'vue-property-decorator';
import { FitWxPhonex } from '@tencent/wphk-ui';
import { biHottag } from '@tencent/ppd-base-libs';

@Component({
  components: {
    FitWxPhonex,
  },
})
export default class CIndex extends Vue {
  eGoDownload() {
    biHottag('wallet.charity.outside.download_click', {
      fopenid: 'opened@wx.hkg',
      fuin: 'opened@wx.hkg',
    });
    goDownloadWx();
  }
}
